/**
 * Returns the value for a css property on the root element.
 * When a unit is specified, the value is returned as a number in px.
 *
 * @param {string} property
 * @param {string} unit
 */

export function getRootPropertyValue(
	property: string,
	unit: string = "",
): number | string {
	const computedStyle = getComputedStyle(document.documentElement);
	const value = computedStyle.getPropertyValue(property);

	if (unit === "") return value;

	const numberValue = Number(value?.split(unit)[0] || 0);

	if (unit !== "rem") return numberValue;

	return numberValue * Number(computedStyle.fontSize.split("px")[0]);
}
